module.exports = __webpack_public_path__ + "img/Double Win Slots.a986a384.png";